<template>
  <PageTermsList
    :letters="letters"
    :terms = "terms"/>
</template>

<script>
import AppRouteMixin from '~/mixins/AppRouteMixin'
import PageTermsList from '@theme/components/content/PageTermsList'

const PAGE = {
  name: 'RouteTermsList',
  nuxtI18n: {
    paths: {
      cs: '/slovnik',
      de: '/wortschatz',
      en: '/vocabulary',
      sk: '/slovnik',
    },
  },
  middleware({ store }) {
    store.commit('locale/SET_ALTERNATIVE_PATHS', PAGE.nuxtI18n.paths)
  },
  components: {
    PageTermsList,
  },
  mixins: [AppRouteMixin],
  async asyncData({ store, query, redirect, route }) {
    // TODO add letters from BE to prevent rendering empty lines @GF
    const letters = 'abcdefghijklmnopqrstuvwxyz'.split('')
    if (query.l && letters.indexOf(query.l) === -1) {
      redirect(route.path)
    }
    store.commit('locale/SET_CANONICALS')
    return {
      terms: await store.dispatch('term/LOAD_TERMS'),
      letters, // TODO: pass in params to page component, we need it for validation/redirect
    }
  },
}
export default PAGE
</script>
